import ContactHeader from "./ContactHeader";
import ContactSupport from "./ContactSupports";
import ContactCTA from "./ContactCta";
import { Box } from "@mui/material";

export const ContactUsPage = () => {
  return (
    <Box
      sx={{
        backgroundColor: "rgba(255, 255, 255, 1)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        alignItems: "center",
        justifyContent: "start",
      }}
    >
      <ContactHeader />
      <ContactSupport />
      <ContactCTA />
    </Box>
  );
};

export default ContactUsPage;
